export default (px, context = 16) => `${(px / context).toFixed(3)}rem`;

// theme.typography.pxToRem



// WEBPACK FOOTER //
// ./src/styles/pxToRem.js